module.exports = "https://static.wmbcdn.com/uniweb/images/dd347e061ec0ef08f1c5a97ffa93520b.svg";